import { FC } from 'react';
import { Link } from 'react-router-dom';
import { usePathname } from '@/hooks/usePathname.ts';
import { Button, ListItem, ListItemButton } from '@mui/material';
import { adminNavbar, managerNavbar } from '@/layouts/Admin/config-nav.tsx';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { useTranslation } from 'react-i18next';
import LogoutIcon from '@mui/icons-material/Logout';

type NavbarProps = {
  variant?: 'default' | 'dark';
  onClick?: () => void;
};

const Navbar: FC<PropsWithClassName<NavbarProps>> = ({ className, variant = 'default', onClick }) => {
  const pathname = usePathname();
  const { logout, isAdmin, isManager } = useAuthContext();
  const { t } = useTranslation();

  const navData = isAdmin ? adminNavbar : isManager ? managerNavbar : [];

  return (
    <nav className={cn('flex flex-col gap-4 justify-between grow', className)}>
      <ul className="flex flex-col gap-1 m-0 p-0">
        {navData.map((item) => {
          const isActivated = pathname.includes(item.path);

          return (
            <ListItem disablePadding key={item.title}>
              <ListItemButton
                disableGutters
                component={Link}
                onClick={onClick}
                className={cn('flex items-center gap-8 px-4 py-3 rounded', {
                  'text-white': variant === 'default',
                  'bg-white bg-opacity-20': isActivated && variant === 'default',
                  'hover:bg-white hover:bg-opacity-10': !isActivated && variant === 'default',
                  'bg-gray-200': isActivated && variant === 'dark',
                })}
                to={item.path}
              >
                <div className="flex flex-col">{item.icon}</div>

                <span>{t(item.title)}</span>
              </ListItemButton>
            </ListItem>
          );
        })}
      </ul>
      <div className="lg:px-4 flex flex-col">
        <Button
          onClick={logout}
          variant="text"
          color="primary"
          className="text-white normal-case flex justify-start gap-6"
          startIcon={<LogoutIcon />}
          size="large"
        >
          {t('button.logout')}
        </Button>
      </div>
    </nav>
  );
};

export default Navbar;
